import { useTranslation } from 'react-i18next'

import { OpportunityForm as F } from '@percent/domain/volunteering'

export function DescriptionField(
  props: Omit<
    F.DescriptionFieldProps,
    | 'label'
    | 'placeholder'
    | 'aiLoaderTitle'
    | 'aiLoaderSubtitle'
    | 'aiGenerateInfo'
    | 'aiUnavailable'
    | 'aiDisclaimer'
    | 'aiRetry'
    | 'aiGenerate'
    | 'aiGenerationStatus'
    | 'generateOpportunity'
  >
) {
  const { t } = useTranslation()

  return (
    <F.DescriptionField
      {...props}
      label={t('volunteering.opportunity.form.common.overviewSection.descriptionField.label')}
      placeholder={t('volunteering.opportunity.form.common.overviewSection.descriptionField.placeholder')}
      aiDisclaimer=""
      aiLoaderSubtitle=""
      aiGenerateInfo=""
      aiGenerate=""
      aiLoaderTitle=""
      aiRetry=""
      aiUnavailable=""
    />
  )
}
